import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PT from 'prop-types';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import { getIconSize } from '../button/button.utils';
import { ButtonSize, IconButtonColor } from '../../utils/types';
import Styled from './icon-button.styles';
var IconButton = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.IconButton, _extends({}, rest, {
    ref: ref
  }), children && (typeof children === 'function' ? children({
    size: getIconSize(rest.size)
  }) : children));
});
IconButton.defaultProps = {
  size: ButtonSize.Md,
  color: IconButtonColor.Secondary,
  active: false
};
IconButton.propTypes = {
  children: PT.oneOfType([PT.node, PT.func]).isRequired,
  size: PT.oneOf(objectValues(ButtonSize)),
  color: PT.oneOf(objectValues(IconButtonColor)),
  disabled: PT.bool,
  active: PT.bool
};
export default IconButton;